import React, { FunctionComponent, useMemo } from 'react'
import { useIntl } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { getTimeZoneName } from '@lyrahealth-inc/shared-app-logic/src/features/common/utils/timeZoneUtils'

import { BodyText } from '../../atoms/bodyText/BodyText'
import { Title } from '../../atoms/title/Title'
import { BodyTextSize, TitleSize } from '../../styles/typeStyles'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'

export interface ExpandedCalendarBookingHeaderProps {
  startDate: string
  endDate: string
  timeZone: string
  appointmentDuration: number
}

const Container = styled.View({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '16px',
})
export const ExpandedCalendarBookingHeader: FunctionComponent<ExpandedCalendarBookingHeaderProps> = ({
  timeZone,
  appointmentDuration,
  startDate,
  endDate,
}) => {
  const intl = useIntl()
  const { colors } = useTheme() as ThemeType
  const rangeText = useMemo(() => {
    const startMonth = intl.formatDate(startDate, { month: 'short' })
    const endMonth = intl.formatDate(endDate, { month: 'short' })
    const startYear = intl.formatDate(startDate, { year: 'numeric' })
    const endYear = intl.formatDate(endDate, { year: 'numeric' })
    if (startMonth === endMonth && startYear === endYear) {
      return intl.formatDate(endDate, { month: 'long', year: 'numeric' })
    }
    const startDateFormatted = intl.formatDate(startDate, {
      month: 'short',
      year: startYear === endYear ? undefined : 'numeric',
    })

    const endDateFormatted = intl.formatDate(endDate, { month: 'short', year: 'numeric' })
    return `${startDateFormatted} - ${endDateFormatted}`
  }, [intl, startDate, endDate])

  return (
    <Container testID={tID('ExpandedCalendarBookingHeader-container')}>
      <Title text={rangeText} size={TitleSize.MEDIUM} />
      <BodyText
        text={`${appointmentDuration}-min sessions  •  ${getTimeZoneName({ timeZone })} (${getTimeZoneName({
          timeZone,
          timeZoneName: 'short',
        })})`}
        color={colors.textSecondary}
        size={BodyTextSize.SMALL}
      />
    </Container>
  )
}
